<template>
  <div>
    <model-table
      ref="modelTable"
      :collection="tipShareRule.tipPoolShares"
      :submodel="true"
      edit-mode
      :show-filter="false"
      :show-edit="false"
      :columns="[
        {
          name: 'tipPoolTypeId',
          field: tipPoolShare => tipPoolShare.tipPoolType.name,
          editor: {
            component: 'select',
            label: 'Tip Pool Type',
            options: tipPoolTypes.data,
            optionLabel: 'name',
            optionValue: 'id',
            mapOptions: true,
            emitValue: true,
            rules: [val => !$_.isNil(val) || 'Field is required'],
            filterFunction: tipPoolTypeFilterFunction
          }
        },
        {
          name: 'percentage',
          field: (tipPoolShare) => tipPoolShare.sharePercentageThousandths / 1000,
          editor: {
            component: 'input-with-setter',
            label: 'Percentage',
            rules: [
              val => !$_.isNil(val) || 'Field is required',
              val => val >= 0 && val <= 100 || 'Percentage must be between 0 and 100',
              tipPoolSharesTotalPercentageRule
            ],
            type: 'number',
            step: '5',
            min: '0',
            max: '100',
            setter: (row, val) => {
              row.sharePercentageThousandths = val * 1000
            }
          }
        },
        { name: 'actions', label: 'Action', align: 'right' }
      ]"
    />
  </div>
</template>

<script>
import TipShareRule from 'src/models/tip/TipShareRule'
import ModelTable from 'src/modules/admin/components/ModelTable'

export default {
  name: 'TipPoolShareTable',
  components: {
    ModelTable
  },
  props: {
    tipShareRule: {
      type: TipShareRule,
      required: true
    }
  },
  models: {
    tipPoolTypes: {
      fields: ['id', 'name'],
      variables () {
        return {
          searchString: this.tipPoolTypeFilterString,
          limit: 10
        }
      }
    }
  },
  data () {
    return {
      tipPoolTypeFilterString: null
    }
  },
  methods: {
    tipPoolTypeFilterFunction (val, update) {
      update(() => {
        this.tipPoolTypeFilterString = _.isEmpty(val) ? null : val.trim()
      })
    },
    tipPoolSharesTotalPercentageRule () {
      const tipPoolSharesTotalPercentage = _.sumBy(this.tipShareRule.tipPoolShares.data, 'sharePercentageThousandths')

      return tipPoolSharesTotalPercentage === (100 * 1000) || 'Tip Pool Shares must account for exactly 100% of the Tip Out.'
    }
  }
}
</script>
